export default __webpack_public_path__ + "static/media/Logo.f8ea7d03.svg";